import _ from 'lodash'

/**
 * Padroniza o caminho de estocagem e acesso da entidade
 *
 * @param {Keep.Paper.Design.Entity | Keep.Paper.Design.Link | String} target
 *    A entidade, o seu link ou o seu caminho de estocagem.
 */
export function canonicalizePath(context, target) {
  if (_.isString(target)) return target
  return target.site ? `${target.site}/${target.eref}` : target.eref
}

/**
 * Descobre e padroniza o site destino do link.
 *
 * @param {Object} context
 *    O contexto do Vue contendo pelo menos as propriedades $route e $store.
 * @param {Keep.Paper.Design.Link} link
 *    O link a ser investigado.
 * @param {Object} opts
 *    Opções do link:
 *    -   site
 */
export function canonicalizeSite(context, link, opts) {
  const route = context?.$route
  const site = opts?.site || link?.site || route?.params?.site || null
  return (site?.toLowerCase() === 'default') ? null : site
}

/**
 * Padroniza a instância do link.
 *
 * @param {Object} context
 *    O contexto do Vue contendo pelo menos as propriedades $route e $store.
 * @param {Keep.Paper.Design.Link} link
 *    O link a ser padronizado.
 * @param {Object} opts
 *    Opções do link:
 *    -   site
 *    -   form
 *    -   data
 */
export function canonicalizeLink(context, link, opts) {
  const target = _.isString(link) ? { eref: link } : { ...link }

  target.site = canonicalizeSite(context, link, opts)
  target.name = opts?.name || target.name
  target.eref = opts?.eref || target.eref || target.name
  target.rule = opts?.rule || target.rule || []

  target.path = canonicalizePath(context, target)
  target.form = { ...target.form, ...opts?.form }
  target.data = target.data || opts?.data || []

  return target
}

/**
 * Aplica na entidade padrões de referência obtidos do link.
 *
 * @param {Object} context
 *    O contexto do Vue contendo pelo menos as propriedades $route e $store.
 * @param {Keep.Paper.Design.Link} link
 *    O link a ser investigado.
 * @param {Keep.Paper.Design.Status} status
 *    O status a ser padronizado.
 */
export function canonicalizeStatus(context, link, status) {
  status.self = link

  const { entity } = status

  if (entity) {
    entity.eref = link.eref
    entity.self = link

    if (entity.see) {
      entity.site ||= link.site
    } else {
      entity.site = link.site
    }
  }

  return status
}

/**
 * Descobre e constrói um link para a workspace relacionada ao link indicado.
 *
 * @param {Object} context
 *    O contexto do Vue contendo pelo menos as propriedades $route e $store.
 * @param {Keep.Paper.Design.Link} link
 *    O link a ser investigado.
 * @param {Object} opts
 *    Opções do link:
 *    -   site
 *    -   form
 *    -   data
 */
export function canonicalizeWorkspaceLink(context, link, opts) {
  const eref = _.isString(link) ? link : link.eref
  const namespace = eref?.split('.')[0] || 'Index'
  const target = {
    site: link.site,
    eref: `${namespace}.Workspace`
  }
  return canonicalizeLink(context, target, opts)
}
